import PropTypes from 'prop-types';
import React from 'react';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleFullWidthMediaBlock = ({ media = null }) => {
    return (
        <div className='relative h-screen w-screen bg-white'>
            <figure className='relative h-full w-full'>
                <Media { ...media } />
            </figure>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    media: PropTypes.object.isRequired
};


ModuleFullWidthMediaBlock.propTypes = propTypes;

export default ModuleFullWidthMediaBlock;
